import Vue from 'vue';
import VueRouter from 'vue-router';
import routeArrays from "./config";
import store from "../store/index";

import guest from "@/middlewares/guest";
import candidateGuest from "@/middlewares/candidateGuest";
import candidateActiveTesting from "@/middlewares/candidateActiveTesting";

const Home = () => import(/* webpackChunkName: "candidate-auth" */ `@/views/Home.vue`);
const AuthSuccess = () => import(/* webpackChunkName: "candidate-auth" */ `@/views/candidate/auth/AuthSuccess.vue`);
const Identification = () => import(/* webpackChunkName: "candidate-auth" */ `@/views/candidate/auth/Index.vue`);
const Login = () => import(/* webpackChunkName: "candidate-auth" */ `@/views/candidate/auth/Login.vue`);

const AdminLogin = () => import(/* webpackChunkName: "admin-auth" */ `@/views/admin/auth/Login.vue`);

Vue.use( VueRouter );


const baseRoutes = [
    {
        path: '/admin-login',
        name: 'admin.login',
        component: AdminLogin,
        meta: {
            middleware: guest,
        }
    },
    {
        path: '/demo',
        name: 'candidate.login',
        component: Home,
        meta: {
            middleware: candidateGuest
        }
    },
    {
        path: '/identification/success',
        name: 'auth.success',
        component: AuthSuccess,
        meta: {
            middleware: candidateActiveTesting
        }
    },
    // {
    //     path: '/auth/identification',
    //     name: 'auth.identification',
    //     component: Identification,
    //     meta: {
    //         middleware: candidateGuest
    //     }
    // },
    // {
    //     path: '/auth/login',
    //     name: 'auth.login',
    //     component: Login,
    //     meta: {
    //         middleware: candidateGuest
    //     }
    // },
    {
        path: '/admin',
        component: () => import(/*webpackChunkName: "AdminLayout"*/'@/views/admin/layouts/Main'),
        children: routeArrays.admin
    },
    {
        path: '/',
        component: () => import(/*webpackChunkName: "MainLayout"*/'@/views/candidate/layouts/MainLayout'),
        children: routeArrays.candidate,
    },

    {
        path: '/:id/results',
        component: () => import(/*webpackChunkName: "ResultsIndex"*/'@/views/candidate/results/Index'),
        name: 'candidate.results',
        meta: {
            middleware: candidateActiveTesting
        }
    },
    {
        path: '*',
        component: () => import(/*webpackChunkName: "MainLayout"*/'../views/Error404'),
    }
];

const routes = baseRoutes;

const router = new VueRouter( {
    mode: 'history',
    routes
} );

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory( context, middleware, index ) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if ( !subsequentMiddleware ) return context.next;

    try {
        return ( ...parameters ) => {
            // Run the default Vue Router `next()` callback first.
            context.next( ...parameters );
            // Then run the subsequent Middleware with a new
            // `nextMiddleware()` callback.
            const nextMiddleware = nextFactory( context, middleware, index + 1 );
            subsequentMiddleware( { ...context, next: nextMiddleware } );
        };
    }
    catch ( e ) {

    }
}


router.beforeEach( ( to, from, next ) => {

    if ( from.name !== to.name ) {
        store.dispatch( 'heading/flushHeadings' );
    }

    if ( !to.meta )
        return next();

    // Handles middleware
    if ( to.meta.middleware ) {
        const middleware = Array.isArray( to.meta.middleware )
            ? to.meta.middleware
            : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };
        try {
            const nextMiddleware = nextFactory( context, middleware, 1 );
            return middleware[0]( { ...context, next: nextMiddleware } );
        }
        catch ( e ) {

        }
    }

    return next();
} );

export default router
